<template>
  <WrapWithHint
    :content="warning.message"
    tag="span"
    class="icon excipient-warning-icon no-print"
    :class="iconClass"
  >
    <i class="fa fa-circle-info"></i>
  </WrapWithHint>
</template>

<script setup>
  import { computed } from "vue";
  import WrapWithHint from "../wrap-with-hint.vue";

  const props = defineProps({
    warning: {
      type: Object,
      required: true,
      validator: (val) => val && val.type && val.message,
    },
  });

  const iconClass = computed(() => {
    // Use warning color (orange/yellow) for ambiguous, danger color (red) for definite
    return props.warning.type === "definite" ? "has-text-danger" : "has-text-warning";
  });
</script>

<style lang="scss" scoped>
  .excipient-warning-icon {
    cursor: pointer;
    flex-shrink: 0;
    align-self: center;
  }
</style>
